import { CoreButton, CoreModalDialogFooter } from '@components'
import { useExpenseWorkflowCookie } from '@hooks'
import CheckedIcon from '@images/icons/checked.svg?react'
import CreateCustomApprovalMatrixIcon from '@images/icons/create-matrix.svg?react'
import ExpenseWorkflowModalIcon from '@images/icons/expense-workflow-modal.svg?react'
import InviteYourTeamIcon from '@images/icons/invite-team.svg?react'
import SetUpDepartmentsIcon from '@images/icons/set-department.svg?react'
import { paths } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useCallback, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import WorkflowStep from './WorkflowStep'

import './expenseWorkflowModal.scss'

const ExpenseWorkflowModal = () => {
  const { modalHide } = useContext(GlobalContext)

  const history = useHistory()

  const { onSeen } = useExpenseWorkflowCookie()

  const onSetUpApprovalMatrix = useCallback(
    () => history.push(`${paths.userDepartmentManagement()}/departments`),
    [history]
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: set seen flag on mount
  useEffect(() => {
    onSeen()
  }, [])

  return (
    <div className='expense-workflow-modal-wrapper'>
      <div className='expense-workflow-modal-container'>
        <div className='expense-workflow-modal-header'>
          <div className='image'>
            <ExpenseWorkflowModalIcon width={44} height={44} />
          </div>
          <div className='title'>
            {tr(
              'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.TITLE',
              'Take Full Control of Expense Management with Custom Approval Matrix'
            )}
          </div>
        </div>
        <div className='content'>
          <p className='description'>
            {tr(
              'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.DESCRIPTION',
              'Approvals just got more powerful! The new Custom Approval Matrix lets you define a structured, multi-level approval process for each department, ensuring expenses follow the right hierarchy before payment. Here is how you can set up a Custom Approval Matrix:'
            )}
          </p>

          <div className='steps'>
            <WorkflowStep
              icon={<InviteYourTeamIcon width={32} height={32} />}
              index={1}
              title={tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.INVITE_YOUR_TEAM', 'Invite Your Team')}
              description={tr(
                'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.INVITE_YOUR_TEAM_DESCRIPTION',
                'Add team members and assign roles.'
              )}
            />

            <WorkflowStep
              icon={<SetUpDepartmentsIcon width={32} height={32} />}
              index={2}
              title={tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.SET_UP_DEPARTMENTS', 'Set Up Departments')}
              description={tr(
                'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.SET_UP_DEPARTMENTS_DESCRIPTION',
                'Organize expenses by department.'
              )}
            />

            <WorkflowStep
              icon={<CreateCustomApprovalMatrixIcon width={32} height={32} />}
              index={3}
              title={tr(
                'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.SET_UP_APPROVAL_RULES',
                'Create Custom Approval Matrix'
              )}
              description={tr(
                'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.SET_UP_APPROVAL_RULES_DESCRIPTION',
                'Define a structured approval flow.'
              )}
            />
          </div>
          <div className='old-workflow-info'>
            <div className='icon'>
              <CheckedIcon width={24} height={24} />
            </div>
            <div className='info'>
              {tr(
                'FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.OLD_WORKFLOW_INFO',
                "Prefer to keep it simple? No problem! If you don’t set up a matrix, approvals will continue to follow general approval permissions. You can update your team's approval settings anytime from User & Department Management under Settings."
              )}
            </div>
          </div>
        </div>
      </div>

      <CoreModalDialogFooter className='expense-workflow-modal-footer'>
        <div className='actions'>
          <CoreButton
            onClick={onSetUpApprovalMatrix}
            text={tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.CREATE_MATRIX', 'Set Up Approval Matrix')}
            fullWidth
            size='large'
          />
          <CoreButton
            onClick={modalHide}
            text={tr('FRONTEND.EXPENSES.EXPENSE_WORKFLOW_MODAL.SKIP', 'Skip for now')}
            size='large'
            variation='tertiary'
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}

export default ExpenseWorkflowModal
